import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

/** BCP 47 locale tag for Intl APIs from the active customer language. */
export function resolveCustomerLocaleTag(language: string | undefined): string {
  const lang = language ?? 'cs';
  if (lang.startsWith('cs')) {
    return 'cs-CZ';
  }
  if (lang.startsWith('en')) {
    return 'en-GB';
  }
  if (lang.startsWith('sk')) {
    return 'sk-SK';
  }
  return lang.replace('_', '-');
}

export function useCustomerLocaleTag(): string {
  const { i18n } = useTranslation('customer');
  return useMemo(
    () => resolveCustomerLocaleTag(i18n.resolvedLanguage ?? i18n.language),
    [i18n.resolvedLanguage, i18n.language]
  );
}
